import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { setShowForgetPasswordDialog } from '@/redux/global/global.slice';
import { IGlobalState } from '@/redux/global/global';
import ForgetPasswordForm from './ForgetPasswordForm';

function ForgetPasswordDialog({
  variant,
}: {
  variant:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link'
    | 'gradient'
    | 'toolbarActive';
}) {
  const dispatch = useDispatch();

  const { showForgetPasswordDialog: forgetPasswordDialog } = useSelector(
    (state: { global: IGlobalState }) => state.global
  );

  return (
    <Dialog
      open={forgetPasswordDialog}
      onOpenChange={(open) => dispatch(setShowForgetPasswordDialog(open))}
    >
      <DialogTrigger asChild>
        <Button variant={variant} className="text-white hidden">
          Forget Password
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <ForgetPasswordForm />
      </DialogContent>
    </Dialog>
  );
}

export default ForgetPasswordDialog;
